import { LoadablePaint } from '@confluence/loadable';

export const LazyQuestions = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Questions" */ './Questions.tsx')).Questions,
});
